import { useEffect, useRef, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const ITEM_H = 44;

// Sélecteur à molette façon picker natif (clic sur la case → feuille avec colonnes défilantes)
export const WheelSheet = ({ title, columns, onClose, onConfirm }) => {
  const { t } = useAuth();
  const [sel, setSel] = useState(columns.map((c) => c.value));
  const refs = useRef([]);
  const timers = useRef([]);

  useEffect(() => {
    columns.forEach((c, i) => {
      const el = refs.current[i];
      if (el) el.scrollTop = Math.max(0, c.values.indexOf(c.value)) * ITEM_H;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const snapTo = (i, idx, smooth = true) => {
    const el = refs.current[i];
    if (!el) return;
    const clamped = Math.min(columns[i].values.length - 1, Math.max(0, idx));
    setSel((s) => s.map((v, j) => (j === i ? columns[i].values[clamped] : v)));
    el.scrollTo({ top: clamped * ITEM_H, behavior: smooth ? "smooth" : "auto" });
  };

  const onScroll = (i) => {
    clearTimeout(timers.current[i]);
    timers.current[i] = setTimeout(() => {
      const el = refs.current[i];
      if (el) snapTo(i, Math.round(el.scrollTop / ITEM_H));
    }, 80);
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-black/60" onClick={onClose} data-testid="wheel-sheet">
      <div className="card-bg border-app border-t sm:border rounded-t-2xl sm:rounded-2xl w-full sm:max-w-xs p-5 pb-8" onClick={(e) => e.stopPropagation()}>
        <p className="font-heading text-lg font-bold text-center mb-4" data-testid="wheel-title">{title}</p>
        <div className="flex justify-center gap-4">
          {columns.map((c, i) => (
            <div key={c.key} className="flex flex-col items-center">
              <div className="relative h-[220px] w-20 overflow-hidden">
                <div className="pointer-events-none absolute inset-x-0 top-1/2 -translate-y-1/2 h-11 border-y-2 accent-border z-10" />
                <div className="pointer-events-none absolute inset-x-0 top-0 h-[88px] bg-gradient-to-b from-[var(--bg-card)] to-transparent z-10" />
                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[88px] bg-gradient-to-t from-[var(--bg-card)] to-transparent z-10" />
                <div
                  ref={(el) => (refs.current[i] = el)}
                  onScroll={() => onScroll(i)}
                  className="h-full overflow-y-auto snap-y snap-mandatory scrollbar-none"
                  style={{ scrollbarWidth: "none" }}
                  data-testid={`wheel-col-${c.key}`}
                >
                  <div style={{ height: 88 }} />
                  {c.values.map((v, idx) => (
                    <button
                      key={v}
                      type="button"
                      onClick={() => snapTo(i, idx)}
                      className={`w-full snap-center flex items-center justify-center font-heading font-bold transition-colors ${
                        sel[i] === v ? "text-2xl accent" : "text-lg t-secondary"
                      }`}
                      style={{ height: ITEM_H }}
                      data-testid={`wheel-item-${c.key}-${v}`}
                    >
                      {String(v).padStart(c.key === "sec" ? 2 : 1, "0")}
                    </button>
                  ))}
                  <div style={{ height: 88 }} />
                </div>
              </div>
              <p className="text-xs t-secondary mt-2">{c.label}</p>
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={() => onConfirm(sel)}
          className="w-full accent-bg text-slate-900 font-bold h-12 rounded-xl mt-5"
          data-testid="wheel-confirm"
        >
          {t("wheel.validate")}
        </button>
      </div>
    </div>
  );
};
